import styled from 'styled-components';

export const LogoIco = styled.img`
  display: 'block';
  width: 79px;
  height: 24px;
`;

export const DeviderIco = styled.img`
  display: 'block';
  width: 2px;
  height: 24px;
`;

export const Link = styled.a`
  text-decoration: none;
`;

export const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2vh 0;
`;

export const LanguageSwitch = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */
  letter-spacing: 0.1px;
`;

export const SwitchButton = styled.button`
  border: none;
  background: transparent;
  color: ${(props: { active: boolean }) =>
    props.active ? '#FFFFFF' : '#636777'};
  :first-child {
    margin-right: 12px;
  }
  :last-child {
    margin-left: 12px;
  }
`;
